import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <h1 className="home-title">What License Do You Want to Generate?</h1>
      <div className="button-container">
        <Link to="/lease" className="home-button">Lease License</Link>
        <Link to="/exclusive" className="home-button">Exclusive License</Link>
        <Link to="/beatpack" className="home-button">Beat Pack License</Link>
      </div>
    </div>
  );
};

export default Home;
